import React,{useRef,useEffect,useState} from "react";
import { Formik, Form, Field } from "formik";
import { Toast } from 'primereact/toast';

import {warehouseService} from '../../../services/warehouseService';
import { useSelector } from "react-redux";
import { shipmentServices } from "../../../services/shipmentServices";
import {useStock} from '../../../contexts/stockContexts'; 


const ReceiveStockForm = ({ onSubmit,selectedRow,modalshow }) => {

  const toast = useRef(null);   
  const [currencies, setCurrencies] = useState([]);
  const currencyreducer = useSelector((state) => state.currencyreducer);
  const [freightlist,setFreightlist] = useState([]);
  const {updateStock,settingsdata,getSettingValue} = useStock();

  const updateReceivedStock = async (formdata) =>{
     const response = await warehouseService.updatereceivedstocktransfer(formdata);
     if(response.status == 200){
        modalshow(false);
        toast.current.show({ severity: 'success', summary: 'Received stock', detail: 'Updated successfully' }); 
     }else{
        // modalshow(true);
        toast.current.show({ severity: 'error', summary: 'Received stock', detail: 'Not updated' }); 
     }
  }

  useEffect(()=>{
    getcurrency();
    getfreightlist();
  },[])

  const getcurrency = () => {
    currencyreducer
      .then((response) => {
        setCurrencies(response);
      })
      .catch((error) => {});
  };

   const displayCurrency = () => {
    let items = [];
    currencies.forEach((value, index) => {
      items.push(
        <option key={index} value={value.code}>
          {value.code}
        </option>
      );
    });
    return items;
  };


  const getfreightlist = () =>{
      shipmentServices.getfreightlist().then((response)=>{
        console.warn(response);
          if(response.status ==200){
              setFreightlist(response.data.data);  
          }else{
              setFreightlist([]); 
          }
           
        }).catch((error)=>{
              setFreightlist([]); 
        });
    }

  return (
    <>
     <Toast ref={toast} />
    <Formik
      initialValues={{
        received_qty: selectedRow?.received_quantity ?? 0,
        receive_confirm: selectedRow?.receive_confirmed,
        received_by: selectedRow?.received_by,
        damaged_qty: selectedRow?.damaged_qty ?? 0,
        damaged_reason:selectedRow?.damaged_reason ?? '',
        short_qty:selectedRow?.short_qty ?? 0,
        freight_cost_currency:selectedRow?.freight_cost_currency ?? getSettingValue('default_currency'),
        freight_cost:selectedRow?.freight_cost ?? 0,
        freight_provider:selectedRow?.freight_provider ?? 0
      }}
      enableReinitialize
      onSubmit={(values) => {
        // Convert checkbox to yes/no if needed
        const payload = {
          ...values,
          receive_confirm: values.receive_confirm ? "yes" : "no",
          formdata:selectedRow
        };

        // console.log("Form Data:", payload);
        onSubmit && onSubmit(payload);
        updateReceivedStock(payload);
        
      }}
    >
      {({ values,setFieldValue }) => (
        <Form>
          <div className="row">

            {/* Received Quantity */}
            <div className="col-md-12 form-group">
              <label>Received Quantity</label>
              <Field
                type="number"
                name="received_qty"
                className="form-control"
                placeholder="Enter received quantity"
                min="0"
                required
                max={selectedRow?.transfer_quantity}
                onChange={(e) => {
                    const value = e.target.value; 
                    console.log(selectedRow,'selected row');
                    if (value > selectedRow?.transfer_quantity) {
                    e.target.value = selectedRow?.transfer_quantity;
                    setFieldValue('received_qty', selectedRow?.transfer_quantity);
                    } else  {
                        setFieldValue('received_qty', value);
                    // e.target.value = 1;
                    }
                }}
              />
            </div>

            {/* Received Confirm */}
            <div className="col-md-12 form-group">
              <label className="d-block">Received Confirm</label>
              <div className="form-check">
                <Field
                  type="checkbox"
                  name="receive_confirm"
                  className="form-check-input"
                  id="receive_confirm"
                />
                <label
                  className="form-check-label"
                  htmlFor="receive_confirm"
                >
                  Yes
                </label>
              </div>
            </div>

            {/* Received By */}
            <div className="col-md-12 form-group">
              <label>Received By (Email)</label>
              <Field
                type="email"
                name="received_by"
                className="form-control"
                placeholder="Enter receiver email"
                required={values.receive_confirm}
                disabled={!values.receive_confirm}
              />
            </div>


            <div className="col-md-12 form-group">
              <label>Damaged Quantity (Optional)</label>
              <Field
                type="number"
                name="damaged_qty"
                className="form-control"
                placeholder="Enter damaged quantity"
                min="0"
                
                max={selectedRow?.transfer_quantity}
                onChange={(e) => {
                    const value = e.target.value; 
                    // console.log(selectedRow,'selected row');
                    // selectedRow?.transfer_quantity
                    let receivedQty = Number(values.received_qty) || 0;
                    let damagedQty = Number(e.target.value) || 0;
                    let shortQty = Number(values.short_qty) || 0;

                    let transferqty = receivedQty + damagedQty + shortQty;
                    // console.log(transferqty, 'transfer qty');
                    if (transferqty <= selectedRow?.transfer_quantity) {
                        setFieldValue('damaged_qty', value);
                    } 
                }}
              />
            </div>

            <div className="col-md-12 form-group">
              <label>Damaged Reason (Optional)</label>
              <Field
                type="text"
                name="damaged_reason"
                className="form-control"
                placeholder="Enter Reason"
              />
            </div>

            

            <div className="col-md-12 form-group">
              <label>Short Quantity (Optional)</label>
              <Field
                type="number"
                name="short_qty"
                className="form-control"
                placeholder="Enter damaged quantity"
                min="0"
                
                max={selectedRow?.transfer_quantity}
                onChange={(e) => {
                    const value = e.target.value; 
                    // console.log(selectedRow,'selected row');
                    const receivedQty = Number(values.received_qty) || 0;
                    const damagedQty = Number(values.damaged_qty) || 0;
                    const shortQty = Number(e.target.value) || 0;

                    const transferqty = receivedQty + damagedQty + shortQty;
                    console.log(transferqty, 'transfer qty');
                    if (transferqty <= selectedRow?.transfer_quantity) {
                        setFieldValue('short_qty', value);
                    }  
                }}
              />
            </div>

            <div className="col-md-12 form-group">
                <label>Freight Provider</label>
                <Field
                    as="select"
                    name="freight_provider"
                    className="form-control me-2"
                    // style={{ maxWidth: "100px" }}
                >
                     <option value="">Select Provider</option>
                     {freightlist.map((row,index)=>
                        <option value={row.id} key={index}>{row.name}</option>
                      )} 
                </Field>
            </div>

            <div className="col-md-8 form-group">
                <label>Freight Cost</label>
                <div className="d-flex">
                <Field
                    as="select"
                    name="freight_cost_currency"
                    className="form-control me-2"
                    style={{ maxWidth: "100px" }}
                >
                    {displayCurrency()}
                </Field>

                <Field
                    type="number"
                    name="freight_cost"
                    className="form-control"
                    placeholder="Enter freight cost"
                    step="0.01"
                    min="0"
                />
                </div>
            </div>

          </div>

          <div className="row mt-3">
            <div className="col-md-6">
              <button type="submit" className="btn btn-primary w-100">
                Confirm Receipt
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
    </>
  );
};

export default ReceiveStockForm;
